export const DEFAULT_INACTIVITY_TIMEOUT = 2000;

export enum EAutosaveFormEvent {
  MOUSE_DOWN = 'mousedown',
  KEY_DOWN = 'keydown',
  FOCUS = 'focus',
  SCROLL = 'scroll'
}
